<template>
  <div class="details_form_item">
    <Form ref="editModel" :model="editModel" :label-width="100">
      <FormItem label="版本名称：">{{ editModel.versionName }}</FormItem>
      <FormItem label="版本号：">{{ editModel.versionCode }}</FormItem>
      <FormItem label="强制更新：">{{ convertforceUpdate }}</FormItem>
      <FormItem label="服务：">{{ editModel.dicName }}</FormItem>
      <FormItem label="设备">{{ editModel.clientName }}</FormItem>
      <FormItem label="备注">{{ editModel.remark }}</FormItem>
      <FormItem label="更新文件">
        <a :href="filelink">{{ fileName }}</a>
      </FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      organParentName: "",
      filelink: "",
      fileName: "",
      editModel: {},
    };
  },

  computed: {
    convertforceUpdate() {
      return this.editModel.forceUpdate ? "是" : "否";
    },
  },
  created: function () {
    this.editModel = this.currentData;
    if (this.editModel.updateFilePath) {
      let baseUrl = localStorage.getItem("baseURL");
      this.filelink = baseUrl + this.editModel.updateFilePath;
      if (this.filelink && this.filelink.indexOf("/") >= 0) {
        this.fileName = this.filelink.substr(
          this.filelink.lastIndexOf("/") + 1
        );
      }
    }
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>